var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "container", staticClass: "role-member-container" },
    [
      _c("div", { ref: "containerTitle" }, [
        _c("div", { staticClass: "container-title title-second" }, [
          _c("div", [
            _vm._v("全部成员，共 " + _vm._s(_vm.pageparm.total) + " 人")
          ]),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", plain: "", type: "primary" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.handleAdd.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("添加成员")]
              )
            ],
            1
          )
        ])
      ]),
      _c("tableWrap", {
        scopedSlots: _vm._u([
          {
            key: "table",
            fn: function() {
              return [
                _c(
                  "el-table",
                  {
                    ref: "cusChatTable",
                    staticStyle: { "font-size": "13px", color: "#3D3D3D" },
                    attrs: {
                      data: _vm.tableData,
                      fit: "",
                      "highlight-current-row": "",
                      align: "center",
                      "header-cell-style": { background: "#F9F9F9" },
                      height: "calc(100vh - 345px)"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "userName",
                        label: "姓名",
                        "show-overflow-tooltip": "",
                        "min-width": "100"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "qwAccount",
                        label: "企业号",
                        "min-width": "100"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作", "min-width": "100" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              true
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "table-button",
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.handleDel(
                                            scope.$index,
                                            scope.row
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "pagination",
            fn: function() {
              return [
                _c("Pagination", {
                  ref: "pageContainer",
                  attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
                  on: { callBack: _vm.callBack }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("StaffTree", {
        attrs: {
          title: "添加成员",
          dialogVisibleTree: _vm.dialogVisibleTree,
          currentSelectMember: _vm.currentSelectMember
        },
        on: { closeTree: _vm.closeTree, clickSubmitTree: _vm.clickSubmitTree }
      }),
      _c("TipDialog", { ref: "tipdialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }